import React from 'react';

export default function Footer() {    // Not Footers
  let footerStyle = {
    width: "100vw",
    position: "relative",
  };
  return (
    <footer className="bg-dark text-light text-center py-3 mt-auto" style={footerStyle}>
      <div className="container">
        <p className="mb-0">© 2025 TodoApp. Built with <span className="text-danger">&hearts;</span> using Bootstrap.</p>
        <small>Keep track of your tasks efficiently and stay organized!</small>
      </div>
    </footer>
  );
}